import { render, staticRenderFns } from "./RelatedGlossaryTerms.vue?vue&type=template&id=457bf445&scoped=true&"
import script from "./RelatedGlossaryTerms.vue?vue&type=script&lang=ts&"
export * from "./RelatedGlossaryTerms.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedGlossaryTerms.vue?vue&type=style&index=0&id=457bf445&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bf445",
  null
  
)

export default component.exports